import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

export const UPLOAD_SERVICE_TOKEN = new InjectionToken<UploadService>('UPLOAD_SERVICE_TOKEN');

export interface UploadService {
  uploadFile(file: File): Observable<any>;
}
